import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { formatDate } from "../../../../../utils/formatDate";
import { Button, Popconfirm } from "antd";
import { startUpdateBotonesCambioRol } from "../../../../../context/actions/ptActions";

export const AltaCuentaClabe = () => {
  const dispatch = useDispatch();
  const {
    fechaAltaCuentaClabe,
    altaCuentaClabe,
    confirmacionAltaCuentaClabe,
    fechaConfirmacionAltaCuentaClabe,
  } = useSelector((state) => state.ptReducer.ptDetalle.servicioPT);

  const submit = (tipo) => dispatch(startUpdateBotonesCambioRol(tipo))

  //
  return (
    <div className="SmallCard">
      <div>Alta Cuenta Clabe</div>

      {altaCuentaClabe ? (
        <div>{formatDate(fechaAltaCuentaClabe)}</div>
      ) : (
        <div>
          <Popconfirm onConfirm={()=> submit("AltaCuentaClabe")} title="¿Está seguro de establecer estatus?">
            <Button type="link">Establecer</Button>
          </Popconfirm>
        </div>
      )}
      <hr />

      {altaCuentaClabe && (
        <>
          <div>Confirmado</div>
          {confirmacionAltaCuentaClabe ? (
            <div>{formatDate(fechaConfirmacionAltaCuentaClabe)}</div>
          ) : (
            <div>
              <Popconfirm  onConfirm={()=> submit("ConfirmacionAltaCuentaClabe")}  title="¿Está seguro de establecer estatus?">
                <Button type="link">Confirmar</Button>
              </Popconfirm>
            </div>
          )}
        </>
      )}
    </div>
  );
};
